"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../../../index");

var _KycCheckCallModel = _interopRequireDefault(require("../../../models/KycCheckCallModel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ServiceCalls = /*#__PURE__*/function (_React$Component) {
  _inherits(ServiceCalls, _React$Component);

  function ServiceCalls() {
    _classCallCheck(this, ServiceCalls);

    return _possibleConstructorReturn(this, _getPrototypeOf(ServiceCalls).apply(this, arguments));
  }

  _createClass(ServiceCalls, [{
    key: "render",
    value: function render() {
      var process = this.props.process;
      return _react["default"].createElement("div", {
        className: "row",
        style: {
          position: 'relative'
        }
      }, _react["default"].createElement("div", {
        className: "col-sm-12"
      }, _react["default"].createElement("div", {
        className: "element-with-blur"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header marginless"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-exchange",
        "aria-hidden": "true"
      }), "  All calls")), _react["default"].createElement("div", {
        className: "box-body text-white table-word-break"
      }, _react["default"].createElement(_index.AppTable, {
        model: _KycCheckCallModel["default"],
        params: {
          processId: process.id
        }
      })))));
      return null;
    }
  }]);

  return ServiceCalls;
}(_react["default"].Component);

exports["default"] = ServiceCalls;